module.exports = __webpack_public_path__ + "img/badge.e06b7556.svg";